import { IconProps } from 'interfaces';

const Teacup = ({ className = '~w-4/5 ~h-4/5' }: IconProps) => {
  return (
    <svg
      width='45'
      height='45'
      viewBox='0 0 45 45'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M34.2197 19.6875H36.8256C40.2971 19.6875 41.3289 20.1853 41.2453 22.6571C41.1069 26.7514 39.2606 31.5088 31.875 32.8125'
        stroke='#E88800'
        strokeWidth='3'
        strokeLinecap='round'
      />
      <path
        d='M11.1493 38.6522C4.82222 33.7875 3.89002 26.8877 3.75268 19.6877C3.69336 16.5774 4.59611 15.9375 8.73598 15.9375H28.764C32.9038 15.9375 33.8066 16.5774 33.7474 19.6877C33.6099 26.8877 32.6777 33.7875 26.3507 38.6522C24.5501 40.0365 23.0308 40.3125 20.4739 40.3125H17.0262C14.4691 40.3125 12.9498 40.0365 11.1493 38.6522Z'
        fill='#E88800'
        stroke='#E88800'
        strokeWidth='3'
        strokeLinecap='round'
      />
      <path
        d='M18.75 15.9375V25.3125M15.9454 30.5561L16.4928 27.0846C16.6531 26.0677 17.6142 25.3125 18.7478 25.3125C19.8814 25.3125 20.8425 26.0677 21.0028 27.0846L21.5501 30.5561C21.8452 32.427 15.6865 32.1986 15.9454 30.5561Z'
        stroke='white'
        strokeWidth='3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M21.2042 4.6875C20.1791 5.32239 18.7522 7.5 18.7522 10.3125M14.137 7.5C14.137 7.5 13.125 8.4375 13.125 10.3125M26.2522 7.5C25.7398 7.81744 25.3125 9.375 25.3125 10.3125'
        stroke='#E88800'
        strokeWidth='3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default Teacup;
